import { CollectionViewer } from '@angular/cdk/collections';
import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject, Observable } from 'rxjs';
import { MatSort } from '@angular/material/sort';

export class BaseDataSource implements DataSource<Object> {
  protected subject = new BehaviorSubject<Object[]>([]);
  private readonly dataCountSubject = new BehaviorSubject<number>(0);

  dataCount: number = 0;
  readonly dataCount$ = this.dataCountSubject.asObservable();

  sort: MatSort;

  connect(collectionViewer: CollectionViewer): Observable<Object[] | readonly Object[]> {
    return this.subject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.subject.complete();
    this.dataCountSubject.complete();
  }

  clearTable() {
    this.subject.next([]);
    this.setDataCount(0);
  }

  protected setDataCount(value: number): void {
    this.dataCount = value;
    this.dataCountSubject.next(value);
  }
}
